import { render, staticRenderFns } from "./TokenSidebar.vue?vue&type=template&id=57015193&scoped=true"
import script from "./TokenSidebar.vue?vue&type=script&lang=js"
export * from "./TokenSidebar.vue?vue&type=script&lang=js"
import style0 from "./TokenSidebar.vue?vue&type=style&index=0&id=57015193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57015193",
  null
  
)

export default component.exports